export default __webpack_public_path__ + "static/slider-image-3-6c30b61b856cab19b300a58b474c0851.png";